import { render, staticRenderFns } from "./Stars.vue?vue&type=template&id=1705e8ed&scoped=true"
import script from "./Stars.vue?vue&type=script&lang=js"
export * from "./Stars.vue?vue&type=script&lang=js"
import style0 from "./Stars.vue?vue&type=style&index=0&id=1705e8ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1705e8ed",
  null
  
)

export default component.exports